import { equals2 } from "fxjs/es";
export const unsetTargetImage = (self, id) => {
  const empty_grid_layer_el = self._getEmptyGridLayerElThrowable();
  const existing_grid_layer_el = self._getExistingGridLayerElThrowable();
  const target_image_layer_el = self._getTargetImageLayerElThrowable();
  const grid = (() => {
    const grid = self._grids.get(id);
    if (grid == null) {
      throw new Error(`존재하지 않는 grid 입니다.`);
    }
    return grid;
  })();
  if (equals2(self._selected_grid_id)(id)) {
    self.selectGrid(null);
  }
  if (existing_grid_layer_el.contains(grid.existing_grid_el)) {
    existing_grid_layer_el.removeChild(grid.existing_grid_el);
  }
  if (
    grid.target_image_el != null &&
    target_image_layer_el.contains(grid.target_image_el)
  ) {
    const old_target_image_el = grid.target_image_el;
    target_image_layer_el.removeChild(old_target_image_el);
    old_target_image_el.removeChild(grid.dummy_g_el);
    grid.stroke_sync.setEl(grid.dummy_g_el);
  }
  empty_grid_layer_el.appendChild(grid.empty_grid_el);
  self._grids.set(id, {
    ...grid,
    target_image_el: null,
  });
};
